<template>
  <div v-if="isReadyToDraw">
    <MFITTHeader headerTitle="空席照会" :clickBackButtonEvent="backToBooking1Page" />

    <!-- 入力した日付、区間、人数を表示 -->
    <!-- サルーン席の予約変更の場合、inputtedInfoOnBooking.isSaloon:true -->
    <MFITTTicketInfo :isSaloon="inputtedInfoOnBooking.isSaloon" />

    <!-- 取得した列車情報をカードで表示 -->
    <MFITTTrainList :trainLists="vacancyInquiry.train_info" />

    <!-- 前の列車/次の列車のアクションボタン -->
    <MFITTSelectTrain />

    <!-- 空席の見方テーブル -->
    <MFITTSeatGuide />
  </div>

  <!-- 列車が見つからなかった場合のダイアログ -->
  <DialogNotFoundCars ref="DialogNotFoundCars" :closeButtonClicked="backToBooking1Page" />
</template>

<script>
import { onMounted, computed, watchEffect, ref } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";

export default {
  name: "TemplateMfittBooking2",
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();

    const isReadyToDraw = ref(false);

    const DialogNotFoundCars = ref(null);

    // 列車の空席情報
    const vacancyInquiry = computed(
      () => store.getters["MFITT/vacancyInquiry"]
    );

    // フロントで管理してる入力された値
    const inputtedInfoOnBooking = store.getters["MFITT/inputtedInfoOnBooking"];

    // headerのbackButton用の処理。
    // 条件に合う座席がないエラーで画面遷移してきた場合等にうまく動作しないので、明示的にbooking1を指定して戻る
    const backToBooking1Page = () => {
      // 変更操作中の場合は変更の日付選択画面へ
      if (
        inputtedInfoOnBooking.isReservedChange ||
        inputtedInfoOnBooking.isPurchasedChange
      ) {
        router.push({
          name: "MfittMyTicketChange",
          params: { id: inputtedInfoOnBooking.ticketId },
          query: {
            ticketStatus: getTicketStatusForChangePageQuery(),
            coupon_id: route.query.coupon_id,
          },
        });
      } else {
        router.push({
          name: "MfittBooking1",
          query: { coupon_id: route.query.coupon_id },
        });
      }
    };

    const getTicketStatusForChangePageQuery = () => {
      if (inputtedInfoOnBooking.isReservedChange) {
        return "reserved";
      } else if (inputtedInfoOnBooking.isPurchasedChange) {
        return "purchased";
      } else {
        throw "invalid ticket status for change";
      }
    };

    onMounted(() => {
      // 列車が見つからなかった場合
      if (
        vacancyInquiry.value != null &&
        vacancyInquiry.value.train_info.length == 0
      ) {
        DialogNotFoundCars.value.openDialog();
      } else if (
        vacancyInquiry.value != null &&
        vacancyInquiry.value.train_info.length > 0
      ) {
        isReadyToDraw.value = true;
      }
    });

    return {
      isReadyToDraw,
      vacancyInquiry,
      inputtedInfoOnBooking,
      DialogNotFoundCars,
      backToBooking1Page,
    };
  },
};
</script>
